import { render, staticRenderFns } from "./issuereceiveserial.vue?vue&type=template&id=2740d4a2&scoped=true&"
import script from "./issuereceiveserial.vue?vue&type=script&lang=js&"
export * from "./issuereceiveserial.vue?vue&type=script&lang=js&"
import style0 from "./issuereceiveserial.vue?vue&type=style&index=0&id=2740d4a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740d4a2",
  null
  
)

export default component.exports